export enum EPage {
  SEARCH = 'search',
  PROMOS = 'promos',
  CAMPGROUND_LISTING = 'campground-rental',
  CAMPGROUND_SEARCH = 'campground-search',
  ESCAPES_SEARCH = 'escapes-search',
}

export const PAGE_PATHNAME = {
  [EPage.SEARCH]: '/rv-search',
  [EPage.PROMOS]: '/promos',
  [EPage.CAMPGROUND_LISTING]: '/campground-rental',
  [EPage.CAMPGROUND_SEARCH]: '/campground-search',
  [EPage.ESCAPES_SEARCH]: '/escapes-search',
};

export const PAGE_TITLE_SUFFIX = ' | Outdoorsy';
